import { createFileRoute } from '@tanstack/react-router'
import { EarnX } from '@/features/earn-x'
import CoinAnimation from '@/ui/loader'
import { client } from '@/features/query/client'
import {
  getEarnControllerListCompletedQueryKey,
  getEarnControllerListSectionsQueryKey,
  earnControllerListCompleted,
  earnControllerListSections,
} from '@/api/earn/earn'

export const Route = createFileRoute('/earn/')({
  component: EarnRoot,
  loader: async () => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getEarnControllerListSectionsQueryKey(),
        queryFn: () => earnControllerListSections(),
      }),
      client.prefetchQuery({
        queryKey: getEarnControllerListCompletedQueryKey({
          filter: 'completed',
        }),
        queryFn: () => earnControllerListCompleted({ filter: 'completed' }),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function EarnRoot() {
  return <EarnX />
}
